module.exports = __webpack_public_path__ + "assets/img/footer_banner_guide.de7f723b.png";